import { sendGenerateQuestionsFromSpecificStudentsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class GenerateQuestionsFromSpecificStudentsAdapter extends EventAdapter {
  protected intercomEventKey: string;
  protected amplitudeEventFunction =
    sendGenerateQuestionsFromSpecificStudentsEvent;

  constructor(data: GenerateQuestionsFromSpecificStudentsAdapterData) {
    super();
    this.eventData = data;
  }
}

export type GenerateQuestionsFromSpecificStudentsAdapterData = {
  num_students: number;
  num_students_selected: number;
  num_aoi_selected_from_students: string;
  num_questions_to_generate: number;
  generate_explanations: boolean;
};
